import React from 'react';
import { useAuthenticatedUser } from '../../authentication/auth-wrapper';
import { ServiceProviderCalendarShell } from './_shared';
import { useServiceProviderUnits } from './hooks/use-service-provider-units';
import { useGetServiceProviderUnitCalendarEvents } from './hooks/use-get-service-provider-unit-calendar-events';

const UNIT_CALENDAR_HEIGHT_OFFSET_PX = 280;

export function ServiceProviderUnitCalendar() {
  const authenticatedUser = useAuthenticatedUser();
  const { currentUnit } = useServiceProviderUnits();
  const [visibleRange, setVisibleRange] = React.useState<{
    start: Date;
    end: Date;
  } | null>(null);
  const {
    events,
    isLoading,
    createEvent,
    updateEvent,
    markDone,
    cancelEvent,
    unmarkEvent,
    deleteEvent,
    seriesOccurrenceCallbacks,
    reload,
  } = useGetServiceProviderUnitCalendarEvents(visibleRange);

  return (
    <ServiceProviderCalendarShell
      events={events}
      isLoading={isLoading}
      serviceProviderUnitId={currentUnit?.id}
      currentUserId={authenticatedUser?.profile?.id}
      printTitle={currentUnit?.name ?? ''}
      heightOffsetPx={UNIT_CALENDAR_HEIGHT_OFFSET_PX}
      createEvent={createEvent}
      updateEvent={updateEvent}
      markDone={markDone}
      cancelEvent={cancelEvent}
      unmarkEvent={unmarkEvent}
      deleteEvent={deleteEvent}
      seriesOccurrenceCallbacks={seriesOccurrenceCallbacks}
      onVisibleRangeChange={setVisibleRange}
      onFollowupCreated={reload}
      onObservationCreated={reload}
    />
  );
}
